import { useEffect, useState } from "react";
import { Navigate, NavLink, Route, Routes, useNavigate } from "react-router-dom";
import { Login } from "./routes/login";
import { Home } from "./routes/home";
import { Meals } from "./routes/meals";
import { Settings } from "./routes/settings";
import { Spinner } from "./components/Spinner";
import { api } from "./lib/api";

type AuthState = "loading" | "in" | "out";

export function App() {
  const [auth, setAuth] = useState<AuthState>("loading");

  useEffect(() => {
    let alive = true;
    api.me().then((r) => {
      if (alive) setAuth(r.authenticated ? "in" : "out");
    });
    return () => {
      alive = false;
    };
  }, []);

  if (auth === "loading") {
    return (
      <div className="loading">
        <Spinner />
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          auth === "in" ? <Navigate to="/" replace /> : <Login onLogin={() => setAuth("in")} />
        }
      />
      <Route
        path="/*"
        element={
          auth === "out" ? (
            <Navigate to="/login" replace />
          ) : (
            <Shell onLogout={() => setAuth("out")}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/meals" element={<Meals />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Shell>
          )
        }
      />
    </Routes>
  );
}

function Shell({ children, onLogout }: { children: React.ReactNode; onLogout: () => void }) {
  const nav = useNavigate();
  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand-emoji" aria-hidden>
            🍴
          </span>
          Forklore
        </div>
        <nav className="nav">
          <NavLink to="/" end>
            Stats
          </NavLink>
          <NavLink to="/meals">Meals</NavLink>
          <NavLink to="/settings">Settings</NavLink>
        </nav>
        <button
          className="ghost"
          onClick={async () => {
            await api.logout();
            onLogout();
            nav("/login", { replace: true });
          }}
        >
          Sign out
        </button>
      </header>
      <main className="main">{children}</main>
    </div>
  );
}
